module.exports = __webpack_public_path__ + "img/happy-active.e95641a0.svg";